import React, { useMemo, useState, useEffect } from 'react';
import DateSinglePicker from '../../../../../components/datePicker/DateSinglePicker';
import BaseForm from '../../../../../components/form/BaseForm';
import Modal from '../../../../../components/Modal';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import moment, { setDateFormat } from '../../../../../lib/moment';
import WidgetPreviewThumbnail from '../../widgetPreview/WidgetPreviewThumbnail';
import { setWidgetContents } from '../../../../../lib/utils/widgetUtils';
import { WIDGET_PREVIEW_COMPARE_SECTION_ID } from '../../../../../constants/service/app/widgetConstants';
import { checkIsBetween } from '../../../../../lib/common';
import './WidgetPreviewCompareModal.scss';

const WidgetPreviewCompareModal = (props) => {
  const { isOpen, closeModal, scrollToTargetTop, data, currentActivePageWidgetId, settingTimeActivePageWidgetId } =
    props;
  const { pageWidgetPreviewDataList } = data;
  const [settingTimePageWidgetDataList, setSettingTimePageWidgetDataList] = useState([...pageWidgetPreviewDataList]);
  const [exposureDate, setExposureDate] = useState(setDateFormat(moment(), DATE_FORMAT.FULL_DASH_FORMAT));

  useEffect(() => {
    const targetPageWidgetPreviewDataList = pageWidgetPreviewDataList.filter(
      (item) =>
        (!item.widgetInfo.exposureStartDate && !item.widgetInfo.exposureEndDate) ||
        checkIsBetween(
          DATE_FORMAT.FULL_DASH_FORMAT,
          item.widgetInfo.exposureStartDate,
          item.widgetInfo.exposureEndDate,
          exposureDate,
        ),
    );
    setSettingTimePageWidgetDataList(targetPageWidgetPreviewDataList);
  }, [pageWidgetPreviewDataList, exposureDate]);

  const currentTimePageWidgetDataList = useMemo(() => {
    return pageWidgetPreviewDataList.filter(
      (item) =>
        (!item.widgetInfo.exposureStartDate && !item.widgetInfo.exposureEndDate) ||
        checkIsBetween(
          DATE_FORMAT.FULL_DASH_FORMAT,
          item.widgetInfo.exposureStartDate,
          item.widgetInfo.exposureEndDate,
          setDateFormat(moment(), DATE_FORMAT.FULL_DASH_FORMAT),
        ),
    );
  }, [pageWidgetPreviewDataList]);

  return (
    <Modal
      title={'위젯 미리보기'}
      wrapClassName="widget-preview-compare-modal-wrapper"
      isOpen={isOpen}
      width={900}
      height={700}
      padding={'0px'}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="widget-preview-compare">
        <BaseForm
          className="exposure-period"
          label="노출 설정 시점"
          content={
            <DateSinglePicker
              value={exposureDate}
              showTime={true}
              outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
              btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
              format={DATE_FORMAT.FULL_DASH_FORMAT}
              onSelect={setExposureDate}
            />
          }
        />

        <div className="widget-preview-section">
          <div className="original-widget-preview">
            <div className="widget-preview-compare-title">현재 시점 노출</div>

            <div className="widget-preview-wrap">
              <div className="widget-preview-list" id={WIDGET_PREVIEW_COMPARE_SECTION_ID.BEFORE_UPDATED_SECTION}>
                {currentTimePageWidgetDataList.map((widgetPreviewData, index) => {
                  const { widgetInfo, selectedWidgetItemList, widgetDetail, widgetSection } = widgetPreviewData;
                  return (
                    <span
                      key={index}
                      name={`${WIDGET_PREVIEW_COMPARE_SECTION_ID.BEFORE_UPDATED_SECTION}-${widgetPreviewData.widgetInfo.widgetId}`}
                    >
                      {setWidgetContents(widgetInfo, selectedWidgetItemList, widgetDetail, widgetSection, index)}
                    </span>
                  );
                })}
              </div>

              <div className="widget-preview-thumbnail-list">
                {currentTimePageWidgetDataList.map((widgetPreviewData, index) => (
                  <WidgetPreviewThumbnail
                    key={index}
                    widgetNo={index + 1}
                    isActive={currentActivePageWidgetId === widgetPreviewData.widgetInfo.widgetId}
                    scrollToTargetTop={() =>
                      scrollToTargetTop(
                        widgetPreviewData.widgetInfo.widgetId,
                        WIDGET_PREVIEW_COMPARE_SECTION_ID.BEFORE_UPDATED_SECTION,
                      )
                    }
                    widgetType={widgetPreviewData.widgetInfo.widgetType}
                    mainTitle={widgetPreviewData.widgetInfo.mainTitle}
                    subTitle={widgetPreviewData.widgetInfo.subTitle}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="updated-widget-preview">
            <div className="widget-preview-compare-title">설정된 시점 노출</div>

            <div className="widget-preview-wrap">
              <div className="widget-preview-thumbnail-list">
                {settingTimePageWidgetDataList.map((data, index) => (
                  <WidgetPreviewThumbnail
                    key={index}
                    widgetNo={index + 1}
                    isActive={settingTimeActivePageWidgetId === data.widgetInfo.widgetId}
                    scrollToTargetTop={() =>
                      scrollToTargetTop(
                        data.widgetInfo.widgetId,
                        WIDGET_PREVIEW_COMPARE_SECTION_ID.AFTER_UPDATED_SECTION,
                      )
                    }
                    widgetType={data.widgetInfo.widgetType}
                    mainTitle={data.widgetInfo.mainTitle}
                    subTitle={data.widgetInfo.subTitle}
                  />
                ))}
              </div>

              <div className="widget-preview-list" id={WIDGET_PREVIEW_COMPARE_SECTION_ID.AFTER_UPDATED_SECTION}>
                {settingTimePageWidgetDataList.map((widgetPreviewData, index) => {
                  const { widgetInfo, selectedWidgetItemList, widgetDetail, widgetSection } = widgetPreviewData;
                  return (
                    <span
                      key={index}
                      name={`${WIDGET_PREVIEW_COMPARE_SECTION_ID.AFTER_UPDATED_SECTION}-${widgetPreviewData.widgetInfo.widgetId}`}
                    >
                      {setWidgetContents(widgetInfo, selectedWidgetItemList, widgetDetail, widgetSection, index)}
                    </span>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WidgetPreviewCompareModal;
